<template>
  <div>
    <SearchBox ref="SearchBox">
      <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="80px" class="unitWidth" size="small">
        <el-form-item label="所属工厂">
          <el-select v-model="fcIdSelected" placeholder="请选择" :clearable="isclear" :disabled="ischeck" filterable @change="fcChange">
            <el-option v-for="factory in factoryList" :key="factory.value" :label="factory.label" :value="factory.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属车间">
          <el-select v-model="shopSelected" placeholder="请选择" clearable filterable @change="shopChange" :disabled="scopeSelected =='factory'||scopeSelected=='company'">
            <el-option v-for="shop in shopList" :key="shop.value" :label="shop.label" :value="shop.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属工段">
          <el-select v-model="sectionSelected" placeholder="请选择" clearable filterable @change="sectionChange" :disabled="scopeSelected =='shop'|| scopeSelected =='factory'||scopeSelected=='company'">
            <el-option v-for="section in sectionList" :key="section.value" :label="section.label" :value="section.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属产线">
          <el-select v-model="lineSelected" placeholder="请选择" clearable filterable @change="lineChange"
                     :disabled="scopeSelected =='shop'|| scopeSelected =='factory'||scopeSelected=='company'||scopeSelected=='vsm'">
            <el-option v-for="line in lineList" :key="line.value" :label="line.label" :value="line.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="安灯类型">
          <el-select v-model="atId" placeholder="请选择" clearable filterable @change="aTChange">
            <el-option v-for="atype in andonTypelist" :key="atype.atId" :label="atype.atName" :value="atype.atId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="安灯种类">
          <el-select v-model="acCode" placeholder="请选择" clearable filterable @change="aCChange">
            <el-option v-for="acontent in andonContentList" :key="acontent.acId" :label="acontent.acName" :value="acontent.acCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="安灯级别">
          <el-select v-model="andonLeveLSelected" placeholder="请选择" clearable>
            <el-option v-for="level in andonLevelList" :key="level.value" :label="level.label" :value="level.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="安灯状态">
          <el-select v-model="andonStatus" placeholder="请选择" clearable @change="searchTable">
            <el-option label="待接单" value="create"></el-option>
            <el-option label="待完成" value="wait_complete"></el-option>
            <el-option label="待验收" value="wait_accept"></el-option>
            <el-option label="已完成" value="complete"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="安灯来源">
          <el-select v-model="andonSource" placeholder="请选择" clearable @change="searchTable">
            <el-option label="正常安灯" value="normal" />
            <el-option label="吃饭休息" value="rest" />
          </el-select>
        </el-form-item>
        <el-form-item label="安灯编号">
          <el-input v-model.trim="andonCode" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="接单人">
          <el-input v-model.trim="andonRespUserName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="发布人">
          <el-input v-model.trim="pubUserName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="设备编号">
          <el-input v-model.trim="devCode" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="是否编辑">
          <el-select v-model="isEdit" placeholder="请选择" clearable @change="searchTable">
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期">
          <el-date-picker style="width: 50vh" v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="searchTable">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchTable">查询</el-button>
          <el-button v-if="isSkip" @click="getFacility">返回</el-button>
        </el-form-item>
      </el-form>
    </SearchBox>
    <LabelContent title="安灯工单列表" ref="LabelContent">
      <div slot="btns">
        <!--                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"> 新增</el-button>-->
        <!--                <el-button size="small" type="success" @click=";(ifAdd = true),updatehOpen()"> 新增</el-button>-->
        <!-- <el-button size="small" type="warning"> 批量移除</el-button> -->
        <!-- <span v-for="acc in access" v-if="acc=='A012'" style="font-weight: 400;font-size: 15px;">屏蔽：</span>
        <el-switch v-for="acc in access" v-if="acc=='A012'" @change="searchTable" active-value="1" inactive-value="0" v-model="isShield" style="margin-right: 10px;"></el-switch> -->
        <el-button size="small" type="success" v-for="acc in access" v-if="acc=='AO0003'" @click="onMailUser">
          邮件
        </el-button>
        <el-button size="small" type="success" @click="exportAndonOrder"> 导出</el-button>
      </div>
    </LabelContent>
    <div class="tableBox">
      <el-table stripe ref="multipleTable" v-loading="loading" :data="tableData" class="center">
        <!--                <el-table-column type="selection" width="55" />-->
        <el-table-column prop="andonCode" label="安灯编号" width="180" />
        <el-table-column prop="sfName" label="所属机构" width="220">
          <template slot-scope="scope">
            <span>{{scope.row.fcName}}//{{scope.row.shopName}}//{{scope.row.sectionName}}//{{scope.row.lineName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="devCode" label="设备编号" width="120" />
        <el-table-column prop="devName" label="设备名称" width="100" />
        <el-table-column prop="atName" label="安灯类型" width="80" />
        <el-table-column prop="acName" label="安灯种类" width="150" show-overflow-tooltip />
        <el-table-column prop="andonStatus" label="安灯状态" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.andonStatus == 'create'">待接单</span>
            <span v-if="scope.row.andonStatus == 'wait_complete'">待完成</span>
            <span v-if="scope.row.andonStatus == 'wait_accept'">待验收</span>
            <span v-if="scope.row.andonStatus == 'complete'">已完成</span>
          </template>
        </el-table-column>
        <el-table-column prop="pubUserName" label="发布人" width="100" />
        <el-table-column prop="andonRespUserName" label="接单人" width="100" />
        <el-table-column prop="moAdjustProdTime" label="实际影响时间" width="110">
          <template slot-scope="scope">
            <span>{{Math.floor(scope.row.moAdjustProdTime/60)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="andonProbDesc" label="问题描述" min-width="200" show-overflow-tooltip />
        <el-table-column prop="aorSolveDesc" label="处理对策描述" width="110" />
        <el-table-column prop="createTime" label="发布时间" width="160" />
        <el-table-column prop="andonRespTime" label="接单时间" width="160" />
        <el-table-column prop="moRepairStart" label="维修开始时间" width="160" />
        <el-table-column prop="moRepairEnd" label="维修结束时间" width="160" />
        <el-table-column prop="andonCloseTime" label="安灯关闭时间" width="160" />
        <el-table-column prop="isEdit" label="是否编辑">
          <template slot-scope="scope">
            <span>{{scope.row.isEdit ? '是' : '否'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="arTrigger" label="当前安灯级别触发条件" width="220" />
        <el-table-column prop="andonInitLevel" sortable label="安灯初始级别" width="105" />
        <el-table-column prop="arLevel" sortable label="安灯当前级别" width="105" />
        <el-table-column prop="checkInitLevel" sortable label="验收等级" />
        <el-table-column prop="checkLevel" label="验收进度">
          <template slot-scope="scope">
            <span>{{scope.row.checkLevel == 0 ? '未开始': scope.row.checkLevel}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <!--                        <i class="editBtn iconfont u-youjianbianji" @click=";(ifAdd = false), updatehOpen(scope.row)" />-->
            <!--<i class="editBtn iconfont u-youjianbianji" @click=";(ifAdd = false),updatehOpen(scope.row)" />
                        <i class="delBtn iconfont u-shanchu" @click="deleteRow(scope.row)" />-->
            <i class="editBtn iconfont u-youjianbianji" @click="EditorAndonOrder(scope.row)" v-for="acc in access" v-if="acc=='AO0001'" />
            <i class="delBtn iconfont u-shanchu" @click="deleteAndonOrder(scope.row)" v-for="acc in access" v-if="acc=='AO0002'" />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="paginationChange" @current-change="paginationCurrentChange" :current-page="searchParams.page" :page-sizes="[10, 20, 50, 100]" :page-size="searchParams.pageSize"
                     layout="total, sizes, prev, pager, next, jumper" :total="searchParams.pageCount" />
    </div>
    <el-dialog title="安灯报警每日提醒" :visible.sync="userMailShow" width="50%">
      <p style="color: red;margin-top: -2vw;text-align: left;margin-left: 1vw;">系统将每天早上7点，发送昨日安灯完成情况，给以下人员。</p>
      <div style="text-align: left;text-align: left;margin-top: 1.5vw;">
        <!--<el-tag :key="user.ampcId" style="margin-left: 10px"
                        v-for="user in userAndonMailList" closable
                        :disable-transitions="false" @close="onAndonMailUserDelete(user)">
                    {{user.userName}}
                </el-tag>-->
        <div style="margin: 10px">
          <el-select v-model="userSelected" size="small" filterable placeholder="请选择人员" @change="userMailSelect" style="margin-right: 20px">
            <el-option v-for="user in userListToSelect" :key="user.userId" :label="user.userName" :value="user.userId">
            </el-option>
          </el-select>
          <el-select v-model="workSelected" size="small" multiple filterable placeholder="请选择车间" style="margin-right: 20px" collapse-tags>
            <el-option v-for="work in workShopList" :key="work.shopCode" :label="work.shopName" :value="work.shopCode">
            </el-option>
          </el-select>
          <el-button size="small" @click="onAndonUserSelectSubmit">选择提交</el-button>
        </div>
      </div>
      <div class="tableBox">
        <el-table stripe ref="multipleTable" :data="userAndonMailList" class="center">
          <el-table-column prop="userName" label="用户" />
          <el-table-column prop="shopNames" label="车间" />
          <el-table-column label="操作" width="100" fixed="right">
            <template slot-scope="scope">
              <i class="editBtn iconfont u-youjianbianji" @click='editUserAndonMail(scope.row)' />
              <i class="delBtn iconfont u-shanchu" @click='onAndonMailUserDelete(scope.row)' />
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="userMailShow = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  andonContentList,
  AndonMailPushConfigList,
  deleteAndonOrder,
  exportAndonOrder,
  getAllAndonOrder,
  userMailList
} from '../../../libs/api'
import moment from 'moment'

export default {
  name: 'andonOrderList',
  data() {
    return {
      searchParams: {
        param: {},
        pageSize: 10,
        page: 1,
        pageCount: 0
      },
      loading: false,
      isShield: '0',
      andonCode: '',
      pubUserName: '',
      andonRespUserName: '',
      devCode: '',
      isEdit: '',
      andonSource: '',
      tableData: [],
      factoryTree: [],
      fcIdSelected: '',
      sectionSelected: '',
      shopSelected: '',
      lineSelected: '',
      scopeSelected: '',
      aTypeSelected: '',
      aCSelected: '',
      atId: '',
      acCode: '',
      andonLeveLSelected: '',
      andonStatus: '',
      scopeDisabled: true,
      ischeck: false,
      userInfo: {},
      role: {},
      andonLevelList: [
        {
          value: 1,
          label: '一级'
        },
        {
          value: 2,
          label: '二级'
        },
        {
          value: 3,
          label: '三级'
        }
      ],
      andonTypelist: [],
      andonContentList: [],
      dateRange: '',
      access: [],
      isclear: false,
      userSpeArray: {},
      acoUSpeArray: {},
      anDonManuSpeArray: {},
      fcCode: '',
      userMailShow: false,
      userAndonMailList: [],
      userSelected: '',
      userMailList: [],
      userListToSelect: [],
      workSelected: [],
      workShopList: [],
      andonOrderFacArray: {},
      isSkip: false
    }
  },
  computed: {
    factoryList: function () {
      var arr = []
      var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      if (this.factoryTree != undefined && this.factoryTree.length > 0) {
        if (this.ischeck) {
          for (var i = 0; i < this.factoryTree.length; i++) {
            for (let j = 0; j < userInfo.roles.length; j++) {
              if (this.factoryTree[i].deptID == userInfo.roles[j].factoryId) {
                arr.push({
                  label: this.factoryTree[i].deptName,
                  id: this.factoryTree[i].deptID,
                  value: JSON.stringify(this.factoryTree[i]),
                  deptLevel: this.factoryTree[i].deptLevel,
                  parent: 0
                })
              }
            }
          }
        } else {
          for (var i = 0; i < this.factoryTree.length; i++) {
            arr.push({
              label: this.factoryTree[i].deptName,
              id: this.factoryTree[i].deptID,
              value: JSON.stringify(this.factoryTree[i]),
              deptLevel: this.factoryTree[i].deptLevel,
              parent: 0
            })
          }
        }
      }
      return arr
    },
    shopList: function () {
      var arr = []
      if (this.fcIdSelected != undefined && this.fcIdSelected.length > 0) {
        var factory = JSON.parse(this.fcIdSelected)
        var shops = factory.child
        for (var i = 0; i < shops.length; i++) {
          if (shops[i].hasOwnProperty('deptCode')) {
            arr.push({
              label: shops[i].deptName,
              id: shops[i].deptID,
              value: JSON.stringify(shops[i]),
              deptLevel: shops[i].deptLevel,
              parent: 0
            })
          }
        }
      }
      return arr
    },
    sectionList: function () {
      var arr = []
      if (this.shopSelected != undefined && this.shopSelected.length > 0) {
        var shop = JSON.parse(this.shopSelected)
        var vsms = shop.child
        for (var i = 0; i < vsms.length; i++) {
          if (vsms[i].hasOwnProperty('deptCode')) {
            arr.push({
              label: vsms[i].deptName,
              id: vsms[i].deptID,
              value: JSON.stringify(vsms[i]),
              deptLevel: vsms[i].deptLevel,
              parent: 0
            })
          }
        }
      }
      return arr
    },
    lineList: function () {
      var arr = []
      if (this.sectionSelected != undefined && this.sectionSelected.length > 0) {
        var vsm = JSON.parse(this.sectionSelected)
        var lines = vsm.child
        for (var i = 0; i < lines.length; i++) {
          if (lines[i].hasOwnProperty('deptCode')) {
            arr.push({
              label: lines[i].deptName,
              id: lines[i].deptID,
              value: JSON.stringify(lines[i]),
              deptLevel: lines[i].deptLevel,
              parent: 0
            })
          }
        }
      }
      return arr
    }
  },
  mounted() {
    this.init()
  },
  activated() {
    this.init()
  },
  methods: {
    init() {
      // this.userInfo = sessionStorage.getItem("userInfo")
      this.userInfo = this.$store.state.userInfo
      this.access = JSON.parse(sessionStorage.getItem('auths'))
      var role = this.userInfo.roles
      for (var i = 0; i < role.length; i++) {
        //所有工厂数据
        if (role[i].factoryId == 0) {
          this.ischeck = false
          this.role = role[i]
          this.scopeDisabled = false
          this.isclear = true
          break
        } else {
          if (this.userInfo.factoryId == role[i].factoryId) {
            this.role = role[i]
          }
        }
      }
      this.getData()
      this.getAndonType()
    },
    getFacility() {
      this.$router.push({
        name: 'facilitySpectaculars',
        params: {
          full: 'true'
        }
      })
    },
    paginationChange(val) {
      this.searchParams.pageSize = val
      this.searchTable()
    },
    paginationCurrentChange(val) {
      this.searchParams.page = val
      this.searchTable()
    },
    fcChange: function () {
      this.shopSelected = ''
      this.sectionSelected = ''
      this.lineSelected = ''
      this.acCode = ''
      this.andonContentList = []
      this.searchTable()
      this.getAndonContent()
    },
    shopChange: function () {
      this.sectionSelected = ''
      this.lineSelected = ''
      this.searchTable()
    },
    sectionChange: function () {
      this.lineSelected = ''
      this.searchTable()
    },
    lineChange: function () {
      this.searchTable()
    },
    aTChange() {
      this.acCode = ''
      this.searchTable()
      this.getAndonContent()
    },
    aCChange() {
      this.searchTable()
    },
    deleteAndonOrder(row) {
      this.$confirm('是否确定删除该数据, 是否继续?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http
            .request({
              method: 'GET',
              url: this.$api.deleteAndonOrder + row.andonCode
            })
            .then(response => {
              this.searchTable()
              // this.$message.success(response.message);
            })
            .catch(err => {
              this.searchTable()
              // this.$message.error(err);
            })
        })
        .catch(() => {
          this.searchTable()
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    userMailSelect() {
      let flag = true
      let shopCodes = ''
      for (let i = 0; i < this.userListToSelect.length; i++) {
        if (this.userSelected == this.userListToSelect[i].userId) {
          if (this.userListToSelect[i].ampcId != undefined && this.userListToSelect[i].ampcId != '') {
            flag = false
          }
        }
      }
      if (!flag) {
        for (let a0 = 0; a0 < this.userAndonMailList.length; a0++) {
          if (this.userSelected == this.userAndonMailList[a0].pushUser) {
            shopCodes = this.userAndonMailList[a0].shopCodes
          }
        }
        this.workSelected = shopCodes.split(',')
      } else {
        this.workSelected = []
      }
      //强制刷新
      this.$forceUpdate()
    },
    onAndonUserSelectSubmit() {
      let params = {}
      let shopCodes = ''
      let shopNames = ''
      let flag = true
      if (this.userSelected == undefined || this.userSelected == '') {
        this.$message.error('请选择用户！')
        return
      }
      if (this.workSelected.length == 0) {
        this.$message.error('请选择车间！')
        return
      }
      for (let i = 0; i < this.userListToSelect.length; i++) {
        if (this.userSelected == this.userListToSelect[i].userId) {
          if (this.userListToSelect[i].ampcId != undefined && this.userListToSelect[i].ampcId != '') {
            flag = false
            params['ampcId'] = this.userListToSelect[i].ampcId
          }
        }
      }
      for (let i = 0; i < this.workSelected.length; i++) {
        for (let j = 0; j < this.workShopList.length; j++) {
          if (this.workSelected[i] == this.workShopList[j].shopCode) {
            shopCodes += this.workShopList[j].shopCode + ','
            shopNames += this.workShopList[j].shopName + ','
          }
        }
      }
      shopCodes = shopCodes.substring(0, shopCodes.length - 1)
      shopNames = shopNames.substring(0, shopNames.length - 1)
      if (this.userSelected != undefined && this.userSelected != '') {
        params['pushUser'] = this.userSelected
      }
      if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
        params['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
      }
      if (shopCodes != undefined && shopCodes != '') {
        params['shopCodes'] = shopCodes
      }
      if (shopNames != undefined && shopNames != '') {
        params['shopNames'] = shopNames
      }
      params['ampcType'] = 'andon'
      this.saveAndonMailUserSubmit(params, flag)
    },
    saveAndonMailUserSubmit(params, flag) {
      let options = {
        method: 'POST',
        url: flag ? this.$api.addAndonMailPushConfig : this.$api.editAndonMailPushConfig,
        data: params
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          this.userSelected = ''
          this.workSelected = []
          this.getAndonMailPushConfigList()
        } else {
          this.$message.error(response.message)
        }
      })
    },
    onAndonMailUserDelete(user) {
      this.$confirm('是否确定删除该数据, 是否继续?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http
          .request({
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            params: {
              ampcId: user.ampcId
            },
            url: this.$api.delAndonMailPushConfig
          })
          .then(response => {
            this.getUserMailList()
            if (response.status == 100) {
              this.$message.success("删除成功");
            }
          })
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除",
        });
      });
    },
    editUserAndonMail(row) {
      var flag = true
      if (this.userListToSelect.length != 0) {
        for (let a0 = 0; a0 < this.userListToSelect.length; a0++) {
          if (row.pushUser == this.userListToSelect[a0].userId) {
            flag = false
          }
        }
      }
      if (flag) {
        let array = {
          ampcId: row.ampcId,
          userId: row.pushUser,
          userName: row.userName
        }
        this.userListToSelect.push(array)
      }
      this.userSelected = row.pushUser
      var shopCodes = row.shopCodes.split(',')
      this.workSelected = shopCodes
    },
    onMailUser() {
      if (this.fcIdSelected == undefined || this.fcIdSelected == '') {
        this.$message.error('请选择工厂！')
        return
      }
      this.userAndonMailList = []
      this.userMailShow = true
      this.getUserMailList()
    },
    getAndonMailPushConfigList() {
      let params = {}
      if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
        params['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
      }
      params['ampcType'] = 'andon'
      let options = {
        method: 'get',
        url: this.$api.AndonMailPushConfigList,
        params: params
      }
      this.$http.request(options).then(response => {
        this.userListToSelect = JSON.parse(JSON.stringify(this.userMailList))
        if (response.data != undefined && response.data != '') {
          if (response.status == 100 && response.data.length > 0) {
            this.userAndonMailList = response.data
            this.userAndonMailList.forEach(mail => {
              for (var i = this.userListToSelect.length - 1; i >= 0; i--) {
                if (this.userListToSelect[i].userId == mail.pushUser)
                  this.userListToSelect.splice(i, 1)
              }
            })
          }
        } else {
          this.userAndonMailList = []
        }
      })
    },
    getUserMailList() {
      let params = {}
      this.userSelected = ''
      if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
        params['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
      }
      params['ampcType'] = 'andon'
      let options = {
        method: 'get',
        url: this.$api.userMailList,
        params: params
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          if (response.data != undefined && response.data != '') {
            this.userMailList = response.data
          } else {
            this.userMailList = []
          }
          this.getAndonMailPushConfigList()
          this.getWorkShopList()
        }
      })
    },
    getWorkShopList() {
      let params = {}
      this.workSelected = []
      if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
        params['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
      }
      let options = {
        method: 'get',
        url: this.$api.getWorkShopList,
        params: params
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          if (response.data != undefined && response.data != '') {
            this.workShopList = response.data
          } else {
            this.workShopList = []
          }
        }
      })
    },
    async exportAndonOrder() {
      let queryParams = {}
      var self = this
		console.log("设备",this.atId)
     if (self.atId != undefined && self.atId != '') {

		console.log("设备",this.atId)
		queryParams['atId'] = this.atId
      }
	 
      if (self.aCSelected != undefined && self.aCSelected != '') {
        queryParams['acCode'] = JSON.parse(self.aCSelected).acCode
      }
      if (self.andonLeveLSelected != '') {
        queryParams['andonInitLevel'] = self.andonLeveLSelected
      }
      if (self.scopeSelected != undefined && self.scopeSelected != '') {
        queryParams['arScope'] = self.scopeSelected
      }
      if (self.fcIdSelected != undefined && self.fcIdSelected != '') {
        queryParams['fcCode'] = JSON.parse(self.fcIdSelected).deptCode
      }
	  console.log('工厂', typeof self.fcIdSelected)
      if (self.shopSelected != undefined && self.shopSelected != '') {
        queryParams['shopCode'] = JSON.parse(self.shopSelected).deptCode
      }
      if (self.sectionSelected != undefined && self.sectionSelected != '') {
        queryParams['sectionCode'] = JSON.parse(self.sectionSelected).deptCode
      }
      if (self.lineSelected != undefined && self.lineSelected != '') {
        queryParams['lineCode'] = JSON.parse(self.lineSelected).deptCode
      }
      if (self.andonCode != undefined && self.andonCode != '') {
        queryParams['andonCode'] = self.andonCode
      }
      if (self.andonStatus != undefined && self.andonStatus != '') {
        queryParams['andonStatus'] = self.andonStatus
      }
      if (self.pubUserName != undefined && self.pubUserName != '') {
        queryParams['pubUserName'] = self.pubUserName
      }
      if (self.andonRespUserName != undefined && self.andonRespUserName != '') {
        queryParams['andonRespUserName'] = self.andonRespUserName
      }
      if (self.dateRange != null && self.dateRange != '') {
        if (self.dateRange.length > 0 && self.dateRange[0] != '') {
          queryParams['startTime'] = self.dateFormat(self.dateRange[0]) + ' 00:00:00'
          queryParams['endTime'] = self.dateFormat(self.dateRange[1]) + ' 23:59:59'
        }
      }
      let options = {
        method: 'POST',
        params: queryParams,
        url: this.$api.exportAndonOrder,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json;application/ms-excel;application/ms-excel;charset=utf-8'
        }
      }
      let result = await this.$http.request(options)
      var elink = document.createElement('a')
      elink.download = '安灯工单信息'  //设置名称
      elink.style.display = 'none'
      var blob = new Blob([result], { type: 'application/vnd.ms-excel' })
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)  //追加节点
      elink.click()
      document.body.removeChild(elink)  //删除节点
    },
    searchTable() {
      let queryParams = {
        pageSize: this.searchParams.pageSize,
        pageNum: this.searchParams.page,
        isShield: this.isShield.toString(),
      }
      console.log('isShield', typeof queryParams.isShield)
      var self = this
      if (self.atId != undefined && self.atId != '') {
        queryParams['atId'] = self.atId
      }
      if (self.acCode != undefined && self.acCode != '') {
        queryParams['acCode'] = self.acCode
      }
      if (self.andonLeveLSelected != '') {
        queryParams['andonInitLevel'] = self.andonLeveLSelected
      }
      if (self.scopeSelected != undefined && self.scopeSelected != '') {
        queryParams['arScope'] = self.scopeSelected
      }
      if (self.fcIdSelected != undefined && self.fcIdSelected != '') {
        queryParams['fcCode'] = JSON.parse(self.fcIdSelected).deptCode
      }
      if (self.shopSelected != undefined && self.shopSelected != '') {
        queryParams['shopCode'] = JSON.parse(self.shopSelected).deptCode
      }
      if (self.sectionSelected != undefined && self.sectionSelected != '') {
        queryParams['sectionCode'] = JSON.parse(self.sectionSelected).deptCode
      }
      if (self.lineSelected != undefined && self.lineSelected != '') {
        queryParams['lineCode'] = JSON.parse(self.lineSelected).deptCode
      }
      if (self.andonCode != undefined && self.andonCode != '') {
        queryParams['andonCode'] = self.andonCode
      }
      if (self.andonStatus != undefined && self.andonStatus != '') {
        queryParams['andonStatus'] = self.andonStatus
      }
      if (self.pubUserName != undefined && self.pubUserName != '') {
        queryParams['pubUserName'] = self.pubUserName
      }
      if (self.andonRespUserName != undefined && self.andonRespUserName != '') {
        queryParams['andonRespUserName'] = self.andonRespUserName
      }
      if (self.dateRange != null && self.dateRange != '') {
        if (self.dateRange.length > 0 && self.dateRange[0] != '') {
          queryParams['startTime'] = self.dateFormat(self.dateRange[0]) + ' 00:00:00'
          queryParams['endTime'] = self.dateFormat(self.dateRange[1]) + ' 23:59:59'
        }
      }
      if (self.devCode != undefined && self.devCode != '') {
        queryParams['devCode'] = self.devCode
      }
      if (self.isEdit != undefined && self.isEdit != '') {
        queryParams['isEdit'] = self.isEdit
      }
      if (self.andonSource != undefined && self.andonSource != '') {
        queryParams['andonSource'] = self.andonSource
      }
      this.loading = true
      let options = {
        method: 'GET',
        params: queryParams,
        url: this.$api.getAllAndonOrder
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          this.tableData = response.data.data.list
          this.searchParams.pageCount = response.data.total
        }
        this.loading = false
      })
    },
    //跳转工单详情页
    EditorAndonOrder(row) {
      this.$router.push({
        name: 'andonOrderDetail',
        params: {
          AndonOrder: row
        }
      })
    },
    getAndonType() {
      let options = {
        method: 'GET',
        url: this.$api.getAllAndonType,
      }
      this.$http.request(options).then(response => {
        this.andonTypelist = response.data
      })
    },
    getAndonContent() {
      let params = {}
      if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
        params['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
      } else {
        return
      }
      if (this.atId != undefined && this.atId != '') {
        params['atId'] = this.atId
      }
      let options = {
        method: 'GET',
        url: this.$api.andonContentList,
        params: params
      }
      this.$http.request(options).then(response => {
        this.andonContentList = response.data
      })
    },
    getData() {
      var self = this
      let options = {
        method: 'GET',
        url: this.$api.departTree
      }
      this.$http.request(options).then(response => {
        this.factoryTree = response.data
        for (var i = 0; i < self.factoryTree.length; i++) {
          if (self.factoryTree[i].deptID == self.role.factoryId) {
            self.fcIdSelected = JSON.stringify(self.factoryTree[i])
          }
          //人员看板
          if (self.$route.params.userSpe != undefined && self.$route.params.userSpe != '') {
            self.userSpeArray = self.$route.params.userSpe
            if (self.userSpeArray.hasOwnProperty('fcCode')) {
              if (self.factoryTree[i].deptCode == self.userSpeArray.fcCode) {
                self.fcIdSelected = JSON.stringify(self.factoryTree[i])
                if (self.userSpeArray.hasOwnProperty('shopCode')) {
                  var shops = JSON.parse(self.fcIdSelected).child
                  for (let j = 0; j < shops.length; j++) {
                    if (shops[j].hasOwnProperty('deptCode')) {
                      if (shops[j].deptCode == self.userSpeArray.shopCode) {
                        self.shopSelected = JSON.stringify(shops[j])
                      }
                    }
                  }
                }
              }
            }
          }
          //声光看板
          if (self.$route.params.acouStoSpe != undefined && self.$route.params.acouStoSpe != '') {
            self.acoUSpeArray = self.$route.params.acouStoSpe
            if (self.acoUSpeArray.hasOwnProperty('fcCode')) {
              if (self.factoryTree[i].deptCode == self.acoUSpeArray.fcCode) {
                self.fcIdSelected = JSON.stringify(self.factoryTree[i])
                if (self.acoUSpeArray.hasOwnProperty('shopCode')) {
                  var shops = JSON.parse(self.fcIdSelected).child
                  for (let j = 0; j < shops.length; j++) {
                    if (shops[j].hasOwnProperty('deptCode')) {
                      if (shops[j].deptCode == self.acoUSpeArray.shopCode) {
                        self.shopSelected = JSON.stringify(shops[j])
                        if (self.acoUSpeArray.hasOwnProperty('sectionCode')) {
                          var sections = JSON.parse(self.shopSelected).child
                          for (let k = 0; k < sections.length; k++) {
                            if (sections[k].hasOwnProperty('deptCode')) {
                              if (sections[k].deptCode == self.acoUSpeArray.sectionCode) {
                                self.sectionSelected = JSON.stringify(sections[k])
                                if (self.acoUSpeArray.hasOwnProperty('lineCode')) {
                                  var lines = JSON.parse(self.sectionSelected).child
                                  for (let l = 0; l < lines.length; l++) {
                                    if (lines[l].hasOwnProperty('deptCode')) {
                                      if (lines[l].deptCode == self.acoUSpeArray.lineCode) {
                                        self.lineSelected = JSON.stringify(lines[l])
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          // 工厂看板待接单维修 andonCreateManu
          if (self.$route.params.andonCreateManu != undefined && self.$route.params.andonCreateManu != '') {
            self.anDonManuSpeArray = self.$route.params.andonCreateManu
            if (self.anDonManuSpeArray.hasOwnProperty('fcCode')) {
              if (self.factoryTree[i].deptCode == self.anDonManuSpeArray.fcCode) {
                self.fcIdSelected = JSON.stringify(self.factoryTree[i])
                if (self.anDonManuSpeArray.hasOwnProperty('shopCode')) {
                  var shops = JSON.parse(self.fcIdSelected).child
                  for (let j = 0; j < shops.length; j++) {
                    if (shops[j].hasOwnProperty('deptCode')) {
                      if (shops[j].deptCode == self.anDonManuSpeArray.shopCode) {
                        self.shopSelected = JSON.stringify(shops[j])
                        if (self.anDonManuSpeArray.hasOwnProperty('sectionCode')) {
                          var sections = JSON.parse(self.shopSelected).child
                          for (let k = 0; k < sections.length; k++) {
                            if (sections[k].hasOwnProperty('deptCode')) {
                              if (sections[k].deptCode == self.anDonManuSpeArray.sectionCode) {
                                self.sectionSelected = JSON.stringify(sections[k])
                                if (self.anDonManuSpeArray.hasOwnProperty('lineCode')) {
                                  var lines = JSON.parse(self.sectionSelected).child
                                  for (let l = 0; l < lines.length; l++) {
                                    if (lines[l].hasOwnProperty('deptCode')) {
                                      if (lines[l].deptCode == self.anDonManuSpeArray.lineCode) {
                                        self.lineSelected = JSON.stringify(lines[l])
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          // 工厂看板待完成维修 andonWaitManu
          if (self.$route.params.andonWaitManu != undefined && self.$route.params.andonWaitManu != '') {
            self.anDonManuSpeArray = self.$route.params.andonWaitManu
            if (self.anDonManuSpeArray.hasOwnProperty('fcCode')) {
              if (self.factoryTree[i].deptCode == self.anDonManuSpeArray.fcCode) {
                self.fcIdSelected = JSON.stringify(self.factoryTree[i])
                if (self.anDonManuSpeArray.hasOwnProperty('shopCode')) {
                  var shops = JSON.parse(self.fcIdSelected).child
                  for (let j = 0; j < shops.length; j++) {
                    if (shops[j].hasOwnProperty('deptCode')) {
                      if (shops[j].deptCode == self.anDonManuSpeArray.shopCode) {
                        self.shopSelected = JSON.stringify(shops[j])
                        if (self.anDonManuSpeArray.hasOwnProperty('sectionCode')) {
                          var sections = JSON.parse(self.shopSelected).child
                          for (let k = 0; k < sections.length; k++) {
                            if (sections[k].hasOwnProperty('deptCode')) {
                              if (sections[k].deptCode == self.anDonManuSpeArray.sectionCode) {
                                self.sectionSelected = JSON.stringify(sections[k])
                                if (self.anDonManuSpeArray.hasOwnProperty('lineCode')) {
                                  var lines = JSON.parse(self.sectionSelected).child
                                  for (let l = 0; l < lines.length; l++) {
                                    if (lines[l].hasOwnProperty('deptCode')) {
                                      if (lines[l].deptCode == self.anDonManuSpeArray.lineCode) {
                                        self.lineSelected = JSON.stringify(lines[l])
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          //新工厂看板
          if (self.$route.params.andonOrder != undefined && self.$route.params.andonOrder != '') {
            self.isSkip = true
            self.andonOrderFacArray = self.$route.params.andonOrder
            let fcCodeList = []
            if (self.andonOrderFacArray.hasOwnProperty('fcCode')) {
              fcCodeList = self.andonOrderFacArray.fcCode.split(',')
            }
            if (fcCodeList.length > 1) {
              self.andonOrderFacArray.fcCode = fcCodeList[0]
            }
            if (self.andonOrderFacArray.hasOwnProperty('fcCode')) {
              if (self.factoryTree[i].deptCode == self.andonOrderFacArray.fcCode) {
                self.fcIdSelected = JSON.stringify(self.factoryTree[i])
                if (self.andonOrderFacArray.hasOwnProperty('shopCode')) {
                  var shops = JSON.parse(self.fcIdSelected).child
                  for (let j = 0; j < shops.length; j++) {
                    if (shops[j].hasOwnProperty('deptCode')) {
                      if (shops[j].deptCode == self.andonOrderFacArray.shopCode) {
                        self.shopSelected = JSON.stringify(shops[j])
                        if (self.andonOrderFacArray.hasOwnProperty('sectionCode')) {
                          var sections = JSON.parse(self.shopSelected).child
                          for (let k = 0; k < sections.length; k++) {
                            if (sections[k].hasOwnProperty('deptCode')) {
                              if (sections[k].deptCode == self.andonOrderFacArray.sectionCode) {
                                self.sectionSelected = JSON.stringify(sections[k])
                                if (self.andonOrderFacArray.hasOwnProperty('lineCode')) {
                                  var lines = JSON.parse(self.sectionSelected).child
                                  for (let l = 0; l < lines.length; l++) {
                                    if (lines[l].hasOwnProperty('deptCode')) {
                                      if (lines[l].deptCode == self.andonOrderFacArray.lineCode) {
                                        self.lineSelected = JSON.stringify(lines[l])
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          } else {
            self.isSkip = false
          }
        }
        if (self.$route.params.userSpe != undefined && self.$route.params.userSpe != '') {
          self.andonCode = self.userSpeArray.andonCode
        }
        if (self.$route.params.acouStoSpe != undefined && self.$route.params.acouStoSpe != '') {
          self.andonCode = self.acoUSpeArray.andonCode
        }
        if (self.$route.params.andonCreateManu != undefined && self.$route.params.andonCreateManu != '') {
          self.andonCode = self.anDonManuSpeArray.andonCode
        }
        if (self.$route.params.andonWaitManu != undefined && self.$route.params.andonWaitManu != '') {
          self.andonCode = self.anDonManuSpeArray.andonCode
        }
        this.searchTable()
        this.getUserMailList()
        this.getAndonContent()
      })
    },
    dateFormat(date) {
      return moment(date).format('YYYY-MM-DD')
    }
  }
}
</script>

<style scoped>
</style>
